// extracted by mini-css-extract-plugin
module.exports = {"settings":"_1Co43KzTWFxD2dhWoiztGz"};